import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Axios from "axios";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import './Declaration.css';

function Declaration() {
  const location = useLocation();
  const passedBarcode = location.state?.lastScannedBarcode || "";
  const [data, setData] = useState([]);
  const [inputValue, setInputValue] = useState(passedBarcode);
  const [searchResults, setSearchResults] = useState([]);

  // Fetch all shelf data once
  useEffect(() => {
    Axios.get("https://nodei.ssccglpinnacle.com/getManageshelf")
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching shelf data:", error);
      });
  }, []);

  // Automatically search when data and passedBarcode are available
  useEffect(() => {
    if (passedBarcode && data.length > 0) {
      handleSearchClick(passedBarcode);
    }
  }, [passedBarcode, data]);

  const handleSearchClick = async (barcodeToSearch = inputValue.trim()) => {
    try {
      const response = await Axios.get(
        `https://nodei.ssccglpinnacle.com/getKey/${barcodeToSearch}`
      );

      const keyToSearch = response.data?.key?.trim() || barcodeToSearch;

      const filteredData = data.filter((item) =>
        item.barcodeData.includes(keyToSearch)
      );

      setSearchResults(filteredData);
    } catch (error) {
      console.error("Error fetching key:", error);
    }
  };

  return (
    <div className="findshelf-wrapper">
      <div className="FindShelfHead">
        <h3 style={{ textAlign: "center" }}>Book Shelf Status</h3>
      </div>

      {/* <input
        className="findsearch"
        type="text"
        placeholder="Search Barcode"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
      />
      <Button className="findshelfbtn" onClick={() => handleSearchClick()}>
        Search
      </Button> */}

      <br />
      <br />

      {searchResults.length > 0 && (
        <Table
          striped
          bordered
          hover
          responsive
          style={{ border: "1px solid black", width: "100%", textAlign: "center" }}
        >
          <thead>
            <tr>
              <th style={{ border: "1px solid black" }}>Warehouse</th>
              <th style={{ border: "1px solid black" }}>Rack No</th>
              <th style={{ border: "1px solid black" }}>Shelf No</th>
              <th style={{ border: "1px solid black" }}>SKU</th>
              <th style={{ border: "1px solid black" }}>Title</th>
              <th style={{ border: "1px solid black" }}>Medium</th>
              <th style={{ border: "1px solid black" }}>Edition</th>
              <th style={{ border: "1px solid black" }}>Book ID</th>
            </tr>
          </thead>
          <tbody>
            {searchResults.map((row, key) => (
              <tr key={key}>
                <td style={{ border: "1px solid black" }}>{row.Warehouse}</td>
                <td style={{ border: "1px solid black" }}>{row.rackno}</td>
                <td style={{ border: "1px solid black" }}>{row.shelfno}</td>
                <td style={{ border: "1px solid black" }}>{row.sku}</td>
                <td style={{ border: "1px solid black" }}>{row.title}</td>
                <td style={{ border: "1px solid black" }}>{row.Medium}</td>
                <td style={{ border: "1px solid black" }}>{row.edition}</td>
                <td style={{ border: "1px solid black" }}>{inputValue}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
}

export default Declaration;
